import { AdminOperatorRun } from "@domain/ai_operator"
import useTranslate from "@hooks/use_translate"
import { Box, Stack, Typography } from "@mui/material"

import { RunTone, runTone } from "./operatorRun.utils"

export function Dot({ tone }: { tone: RunTone }) {
  return (
    <Box
      component="span"
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor: `${tone}.main`,
        flexShrink: 0
      }}
    />
  )
}

type Props = {
  run: Pick<AdminOperatorRun, "status" | "outcome" | "outcomeReason">
}

export function useRunStatusLabel() {
  const { translate } = useTranslate()
  return ({ status, outcome, outcomeReason }: Props["run"]) => {
    if (status !== "SUCCESS" || !outcome) {
      return translate(`ai_operator_status_${status.toLowerCase()}`)
    }
    const label = translate(`ai_operator_outcome_${outcome}`)
    return outcomeReason
      ? `${label} · ${translate(`ai_operator_reason_${outcomeReason}`, outcomeReason)}`
      : label
  }
}

export default function RunStatus({ run }: Props) {
  const label = useRunStatusLabel()
  const tone = runTone(run)
  return (
    <Stack direction="row" alignItems="center" gap={0.75} minWidth={0}>
      <Dot tone={tone} />
      <Typography
        variant="caption"
        fontWeight={600}
        color={tone === "success" ? "text.secondary" : `${tone}.dark`}
        noWrap
      >
        {label(run)}
      </Typography>
    </Stack>
  )
}
